import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
export const api = {
  addEvaluation: ipConfig.api_mwclg + '/mcp/user/addEvaluation',
  getEvaluation: ipConfig.api_mwclg + '/mcp/user/getEvaluation',
  getCusOpAndSales: ipConfig.api_mwclg + '/mcp/user/getCusOpAndSales'
}

// 新增评价
export function addEvaluation (params) {
  return axios({
    url: api.addEvaluation,
    method: 'post',
    data: params
  })
}
// 查询评价
export function getEvaluation (params) {
  return axios({
    url: api.getEvaluation,
    method: 'post',
    data: params
  })
}
// 获取客户下客服和销售
export function getCusOpAndSales (params) {
  return axios({
    url: api.getCusOpAndSales,
    method: 'post',
    data: params
  })
}

export function GetConBaseByCusID (params) {
  return axios({
    url: api.GetConBaseByCusID,
    method: 'get',
    params
  })
}
export function getExportPortList (params) {
  return axios({
    url: api.getExportPortList,
    method: 'post',
    data: params,
    params
  })
}
export function DCInbound (data) {
  return axios({
    url: api.DCInbound,
    method: 'post',
    data
  })
}
export function DCStock (data) {
  return axios({
    url: api.DCStock,
    method: 'post',
    data
  })
}
export function DCOutbound (data) {
  return axios({
    url: api.DCOutbound,
    method: 'post',
    data
  })
}
export function CFSInbound (data) {
  return axios({
    url: api.CFSInbound,
    method: 'post',
    data
  })
}
export function CFSPhoto (data) {
  return axios({
    url: api.CFSPhoto,
    method: 'post',
    data
  })
}
export function DCStockExport (data) {
  return axios({
    url: api.DCStockExport,
    method: 'post',
    data,
    responseType: 'blob'
  })
}
